import { ArrowRightAlt } from '@mui/icons-material';
import { Link, LinkProps, Typography } from '@mui/material';
import { ElementType } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { eventStopPropagation } from '~/util/function/eventStopPropagation';

import { Root, StartIcon } from './DataGridLink.styled';
import { DataGridLinkVariant } from './DataGridLink.types.ts';

const variantMap: { [key in DataGridLinkVariant]: ElementType } = {
  [DataGridLinkVariant.PRIMARY]: (props: LinkProps) => {
    return (
      <Root data-intercom-target="DataGrid/PrimaryLink" {...props}>
        <StartIcon>
          <ArrowRightAlt fontSize="small" />
        </StartIcon>
        {props.children}
      </Root>
    );
  },
  [DataGridLinkVariant.STANDARD]: Link,
};

export interface DataGridLinkProps extends Omit<LinkProps<typeof RouterLink>, 'variant'> {
  variant?: DataGridLinkVariant;
}

export const DataGridLink = ({ variant, ...otherProps }: DataGridLinkProps) => {
  const LinkComponent = variantMap[variant || DataGridLinkVariant.STANDARD];
  if (!otherProps.to) {
    // if the link is empty return only the text
    return <Typography variant="body2">{otherProps.children}</Typography>;
  }
  return <LinkComponent component={RouterLink} color="inherit" onClick={eventStopPropagation} {...otherProps} />;
};
